import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InputNumberModule } from 'primeng/inputnumber';
import { TableModule } from 'primeng/table';

@Component({
  selector: 'app-custom-number-filter',
  templateUrl: './custom-number-filter.component.html',
  styleUrls: ['./custom-number-filter.component.scss'],
  standalone: true,
  imports: [TableModule, FormsModule, ReactiveFormsModule, InputNumberModule]
})
export class CustomNumberFilterComponent {
  @Input() field!: string;
  @Input() control!: FormControl;

  @Output() onChangeNumberFilter = new EventEmitter<{ propertyName: string, valueFilter: any }>();

  filterInput(event: any) {
    const inputElement = event.target as HTMLInputElement;
    if (Number(inputElement.value) === 0) return;
    this.onChangeNumberFilter.emit({ propertyName: this.field, valueFilter: Number(inputElement.value) });
  }
}
